export const STORE_KEY_LANG = "org.prolet.tp.claimform.language";
